module.exports = __webpack_public_path__ + "static/media/sort-alpha-up.790f32d1.svg";